import { Label, Radio } from 'flowbite-react';
import React from 'react';

interface Step1CarteTProps {
  hasCarteT: boolean | null;
  onChange: (value: boolean) => void;
}

const Step1CarteT: React.FC<Step1CarteTProps> = ({ hasCarteT, onChange }) => (
  <div className="space-y-4">
    <h3 className="text-lg font-medium">Avez-vous la carte T ?</h3>
    <div className="flex space-x-4">
      <div className="flex items-center gap-2">
        <Radio
          name="carteT"
          checked={hasCarteT === true}
          onChange={() => onChange(true)}
          id="carteT-yes"
        />
        <Label htmlFor="carteT-yes">Oui</Label>
      </div>
      <div className="flex items-center gap-2">
        <Radio
          name="carteT"
          checked={hasCarteT === false}
          onChange={() => onChange(false)}
          id="carteT-no"
        />
        <Label htmlFor="carteT-no">Non</Label>
      </div>
    </div>
  </div>
);

export default Step1CarteT;


